<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M8.59 16.58 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42Z" />
  </svg>
</template>
